import type { Module } from '@/shared/schemas';
import { ModuleCard } from './ModuleCard';
import styles from './ModuleGrid.module.css';

interface ModuleGridProps {
  readonly modules: readonly Module[];
  readonly isAuthenticated: boolean;
  readonly userId: string | null;
}

export function ModuleGrid({ modules, isAuthenticated, userId }: ModuleGridProps) {
  if (modules.length === 0) {
    return (
      <div className={styles.grid}>
        <div className={styles.empty}>
          <p>No modules match your filters.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {modules.map((module) => (
        <ModuleCard
          key={module.id}
          module={module}
          isAuthenticated={isAuthenticated}
          userId={userId}
        />
      ))}
    </div>
  );
}
